import type { MaybeRef } from "vue"
import type { ServerResponse } from "@/http"
import type { IEventVaultResponse } from "@/types"
import { useQuery } from "@tanstack/vue-query"
import { ref, toValue } from "vue"
import { axios } from "@/axios"
import { EventVault } from "@/models"

interface IListAccessedEventsOptions {
  page?: number
  perPage?: number
}

export async function listAccessedEvents({ page, perPage }: IListAccessedEventsOptions = {}) {
  const response = await axios.get<ServerResponse<IEventVaultResponse[]>>(`/api/guest/events`, { params: { page, perPage } })

  return { events: response?.data?.Data ? response.data.Data.map(event => EventVault.fromResponse(event)) : [], links: response.data.Links }
}

const LIST_ACCESSED_EVENTS_KEY_QUERY_KEY = "listAccessedEvents"

export function useListAccessedEvents({ page, perPage }: { page?: MaybeRef<number>, perPage?: MaybeRef<number> } = {}) {
  const pageCount = ref(1)

  const query = useQuery({
    queryKey: [LIST_ACCESSED_EVENTS_KEY_QUERY_KEY, page, perPage],
    queryFn: async () => {
      const response = await listAccessedEvents({ page: toValue(page), perPage: toValue(perPage) })

      if (response.links?.Last) {
        pageCount.value = Number(response.links.Last)
      }

      return response.events
    },
  })

  return { ...query, pageCount }
}
